/**
 * Adds scroll hints (fade + arrow buttons) to horizontally scrollable
 * variant rows (.variant-option--buttons). Arrows are sticky inside the
 * scroll container, so no wrapper element is needed and the theme's
 * variant-picker morphing keeps working.
 */
const ROW_SELECTOR = '.variant-picker .variant-option--buttons';
const CARET =
  '<svg viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true"><path d="M5.5 3L9.5 7L5.5 11" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg>';

/**
 * Tolerance: a few px of scroll (e.g. iOS nudging the container when a
 * visually-hidden radio input gets focus) must not show the "previous" arrow.
 */
const EDGE = 24;

/** @param {HTMLElement} row */
function update(row) {
  const max = row.scrollWidth - row.clientWidth;
  const canScroll = max > EDGE;
  row.classList.toggle('vscroll--scrollable', canScroll);
  row.classList.toggle('vscroll--at-start', row.scrollLeft <= EDGE);
  row.classList.toggle('vscroll--at-end', row.scrollLeft >= max - EDGE);
}

/** @param {HTMLElement} row */
function init(row) {
  if (row.dataset.vscroll === 'true' && row.querySelector(':scope > .vscroll__hint--next')) return;
  row.querySelectorAll(':scope > .vscroll__hint').forEach((el) => el.remove());
  row.dataset.vscroll = 'true';

  const make = (dir) => {
    const hint = document.createElement('span');
    hint.className = `vscroll__hint vscroll__hint--${dir}`;
    const btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'vscroll__btn';
    btn.setAttribute('aria-label', dir === 'next' ? 'Ver mais opções' : 'Opções anteriores');
    btn.innerHTML = CARET;
    btn.addEventListener('click', (e) => {
      e.preventDefault();
      e.stopPropagation();
      const step = Math.max(120, row.clientWidth * 0.7) * (dir === 'next' ? 1 : -1);
      row.scrollBy({ left: step, behavior: 'smooth' });
    });
    hint.appendChild(btn);
    return hint;
  };

  const legend = row.querySelector(':scope > legend');
  const prev = make('prev');
  if (legend) legend.after(prev);
  else row.prepend(prev);
  row.append(make('next'));

  row.addEventListener('scroll', () => update(row), { passive: true });

  // Focusing a (visually hidden) radio input can nudge the row by a few px;
  // undo that so the row stays exactly where the user left it.
  row.addEventListener('focusin', () => {
    const before = row.scrollLeft;
    requestAnimationFrame(() => {
      if (Math.abs(row.scrollLeft - before) < 40) row.scrollLeft = before;
      update(row);
    });
  });

  if (typeof ResizeObserver !== 'undefined') {
    new ResizeObserver(() => update(row)).observe(row);
  }
  update(row);
}

function scan() {
  document.querySelectorAll(ROW_SELECTOR).forEach((row) => {
    if (row instanceof HTMLElement) init(row);
  });
}

let scheduled = false;
const observer = new MutationObserver(() => {
  if (scheduled) return;
  scheduled = true;
  requestAnimationFrame(() => {
    scheduled = false;
    scan();
  });
});

scan();
observer.observe(document.body, { childList: true, subtree: true });
